import { render, staticRenderFns } from "./staff-roles.vue?vue&type=template&id=c33c623e&"
import script from "./staff-roles.vue?vue&type=script&lang=ts&"
export * from "./staff-roles.vue?vue&type=script&lang=ts&"
import style0 from "./staff-roles.vue?vue&type=style&index=0&id=c33c623e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports